export const SAPAPI_ENVIRONMENTS = ["DEVELOPMENT", "QUALITY", "PRODUCTION"];
export const SAPAPI_PORTALS = ["devportal", "apiportal"];

const PROBE_OUTCOMES = new Set(["success", "timeout", "transport_error", "non_2xx"]);

export function historyEntriesForWindow(history, windowMinutes, now = Date.now()) {
  const entries = Array.isArray(history && history.entries) ? history.entries : [];
  const cutoff = now - windowMinutes * 60 * 1000;
  return entries.filter((entry) => {
    const timestamp = new Date(entry.at).getTime();
    return !Number.isNaN(timestamp) && timestamp >= cutoff;
  });
}

export function portalIsActuallyOnline(portal) {
  return !!portal && portal.actualStatus === "ONLINE";
}

export function hasCompletePortalStatus(status) {
  const portals = status && status.portals;
  return (
    Array.isArray(portals) &&
    SAPAPI_ENVIRONMENTS.every((environment) =>
      SAPAPI_PORTALS.every((portal) =>
        portals.some(
          (entry) =>
            entry &&
            entry.environment === environment &&
            entry.portal === portal &&
            typeof entry.status === "string"
        )
      )
    )
  );
}

export function unavailablePortalStatuses(failure) {
  return SAPAPI_ENVIRONMENTS.flatMap((environment) =>
    SAPAPI_PORTALS.map((portal) => ({
      environment,
      portal,
      status: "WARNING",
      failure,
    }))
  );
}

export function portalLatencyValue(snapshot, environment, portal, metric) {
  if (!["latest", "p50", "p95", "max"].includes(metric)) return null;
  const portals = Array.isArray(snapshot && snapshot.portals) ? snapshot.portals : [];
  const status = portals.find(
    (entry) => entry.environment === environment && entry.portal === portal
  );
  const value = Number(status && status.latency && status.latency[metric]);
  return Number.isFinite(value) && value >= 0 ? value : null;
}

export function portalProbeOutcome(snapshot, environment, portal) {
  const portals = Array.isArray(snapshot && snapshot.portals) ? snapshot.portals : [];
  const status = portals.find(
    (entry) => entry.environment === environment && entry.portal === portal
  );
  return status && PROBE_OUTCOMES.has(status.lastOutcome) ? status.lastOutcome : null;
}
